import { privateFetch } from "../../utils/CustomFetch";
import { CONSTANT } from "../../utils/Constant";

export const SVCountryPhoneRequest = async (page, size ) => {
    let responseData = []
    await privateFetch.get(`maintenance/countryPhone?page=${page}&size=${size}`, {
        headers: {
            ...CONSTANT.HEADER_TYPE,
        },
    })
    .then(async (response)=> {
        responseData = await response.data
    }).catch((error)=> {
        throw new Error (error)
    });

    return responseData
}

export const SVCountryPhoneSaveRequest = async (data) => {
    try {
        const response = await privateFetch.post('maintenance/countryPhone', data, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        return response.data;   
    } catch (error) {
        throw error;
    }
}

export const SVCountryPhoneUpdatedRequest = async (data) => {
    // console.log(data);
    try {
        const response = await privateFetch.patch(`maintenance/countryPhone/${data.id}`,
        {
        }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}

export const SVCountryPhoneDelete = async (id) => {
    try {
        const response = await privateFetch.delete(`maintenance/countryPhone/${id}`, {
            headers: {
                ...CONSTANT.HEADER_TYPE,
            },
        });
        // console.log('RESPONSE:',response);
        if ( response.status === 200) {
            // console.log('SUCESS', response.data);
            return response.data.message;
        } else {
            throw new Error("Error al eliminar.");
        }
    } catch (error) {
        throw error;
    }
}